export enum RolePermissions {
    ViewManagement = 'ViewManagement',
    QueryContributor = 'QueryContributor',
    DataSetContributor = 'DataSetContributor',
    ReportViewContributor = 'ReportViewContributor',
    ResourceStringContibutor = 'ResourceStringContibutor',
    ProviderContributor = 'ProviderContributor',
}